(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["blacklight-bundle-landing"] && !Shopify.designMode) return;
  try {
    
  function setBlacklightMode(section, mode) {
    var isDay = mode === 'day';
    var dayButton = section.querySelector('[data-blacklight-mode="day"]');
    var nightButton = section.querySelector('[data-blacklight-mode="night"]');
    var images = section.querySelectorAll('.blacklight-transform__image');
    var dayImage = section.querySelector('[data-blacklight-day-image]');
    var heading = section.querySelector('[data-blacklight-mode-heading]');
    var copy = section.querySelector('[data-blacklight-mode-copy]');
    var badge = section.querySelector('[data-blacklight-mode-label]');

    var update = function () {
      dayButton.setAttribute('aria-pressed', String(isDay));
      nightButton.setAttribute('aria-pressed', String(!isDay));
      images.forEach(function (image) { image.classList.toggle('is-hidden', image === dayImage ? !isDay : isDay); });
      heading.innerHTML = isDay ? section.dataset.dayHeading : section.dataset.nightHeading;
      copy.innerHTML = isDay ? section.dataset.dayText : section.dataset.nightText;
      badge.textContent = isDay ? section.dataset.dayBadge : section.dataset.nightBadge;
    };

    if (document.startViewTransition) document.startViewTransition(update);
    else update();
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-blacklight-mode]');
    if (!button) return;
    var section = button.closest('[data-blacklight-landing]');
    setBlacklightMode(section, button.dataset.blacklightMode);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dv-collections-directory"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('[data-dv-directory]').forEach((root) => {
      const search = root.querySelector('input[type="search"]');
      const clear = root.querySelector('[data-dv-clear]');
      const results = root.querySelector('[data-dv-results]');
      const resultGrid = root.querySelector('[data-dv-result-grid]');
      const resultHeading = root.querySelector('[data-dv-result-heading]');
      const departments = root.querySelector('[data-dv-departments]');
      const az = root.querySelector('[data-dv-az]');
      const productSearch = root.querySelector('[data-dv-product-search]');
      const catalog = [];
      const seen = new Set();

      root.querySelectorAll('[data-dv-search-item]').forEach((link) => {
        if (!seen.has(link.href)) {
          seen.add(link.href);
          catalog.push({ href: link.href, title: link.textContent.trim(), group: link.dataset.dvGroup || '' });
        }
      });

      const render = () => {
        const query = search.value.trim().toLowerCase();
        clear.hidden = !query;
        results.hidden = !query;
        departments.hidden = Boolean(query);
        az.hidden = Boolean(query);
        resultGrid.replaceChildren();
        if (!query) return;

        const words = query.split(/\s+/);
        const matches = catalog.filter((item) => words.every((word) => `${item.title} ${item.group}`.toLowerCase().includes(word)));
        resultHeading.textContent = matches.length ? `${matches.length} ${matches.length === 1 ? 'collection' : 'collections'} found` : 'No matching collections';

        matches.forEach((item) => {
          const link = document.createElement('a');
          const text = document.createElement('span');
          const group = document.createElement('small');
          const arrow = document.createElement('b');
          link.href = item.href;
          text.textContent = item.title;
          group.textContent = item.group;
          arrow.textContent = '→';
          arrow.setAttribute('aria-hidden', 'true');
          text.append(group);
          link.append(text, arrow);
          resultGrid.append(link);
        });

        productSearch.href = `${window.Shopify.routes.root}search?type=product&q=${encodeURIComponent(search.value.trim())}`;
      };

      search.addEventListener('input', render);
      clear.addEventListener('click', () => {
        search.value = '';
        render();
        search.focus();
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  function resetBlacklightFile(panel) {
    var fileInput = panel.querySelector('[data-blacklight-file-input]');
    var preview = panel.querySelector('[data-blacklight-file-preview]');
    var previewImage = panel.querySelector('[data-blacklight-preview-image]');
    fileInput.value = '';
    panel.querySelector('[data-blacklight-file-name]').textContent = panel.dataset.emptyLabel;
    preview.hidden = true;
    if (previewImage.dataset.objectUrl) URL.revokeObjectURL(previewImage.dataset.objectUrl);
    previewImage.removeAttribute('src');
    delete previewImage.dataset.objectUrl;
  }

  function previewBlacklightFile(panel, file) {
    var preview = panel.querySelector('[data-blacklight-file-preview]');
    var previewImage = panel.querySelector('[data-blacklight-preview-image]');
    if (previewImage.dataset.objectUrl) URL.revokeObjectURL(previewImage.dataset.objectUrl);
    var objectUrl = URL.createObjectURL(file);
    previewImage.src = objectUrl;
    previewImage.dataset.objectUrl = objectUrl;
    preview.hidden = false;
  }

  function updateBlacklightUpload(root) {
    var panel = root.querySelector('[data-blacklight-custom-upload]');
    if (!panel) return;

    var selectedValues = [];
    root.querySelectorAll('.product-detail__options input[type="radio"]:checked').forEach(function (input) {
      selectedValues.push(input.value.toLowerCase());
    });
    root.querySelectorAll('.product-detail__options select').forEach(function (select) {
      selectedValues.push(select.value.toLowerCase());
    });
    root.querySelectorAll('.product-detail__options [role="option"][aria-selected="true"]').forEach(function (option) {
      selectedValues.push(option.dataset.value.toLowerCase());
    });
    var selectedVariant = root.querySelector('[data-product-select] option:checked');
    if (selectedVariant) selectedValues.push(selectedVariant.textContent.toLowerCase());

    var triggerValue = (panel.dataset.triggerValue || 'Custom Artwork').toLowerCase();
    var showUpload = selectedValues.some(function (value) { return value.indexOf(triggerValue) !== -1; });
    var fileInput = panel.querySelector('[data-blacklight-file-input]');
    panel.hidden = !showUpload;
    fileInput.required = showUpload;
    if (!showUpload) {
      resetBlacklightFile(panel);
    }
  }

  function initializeBlacklightUploads(scope) {
    scope.querySelectorAll('[data-section-type="product"]').forEach(function (root) {
      updateBlacklightUpload(root);
    });
  }

  initializeBlacklightUploads(document);

  document.addEventListener('change', function (event) {
    var root = event.target.closest('[data-section-type="product"]');
    if (!root) return;

    if (event.target.matches('[data-blacklight-file-input]')) {
      var label = root.querySelector('[data-blacklight-file-name]');
      var panel = event.target.closest('[data-blacklight-custom-upload]');
      if (event.target.files.length) {
        label.textContent = event.target.files[0].name;
        previewBlacklightFile(panel, event.target.files[0]);
      } else {
        resetBlacklightFile(panel);
      }
    }
    updateBlacklightUpload(root);
  });

  document.addEventListener('click', function (event) {
    var removeButton = event.target.closest('[data-blacklight-file-remove]');
    if (removeButton) {
      resetBlacklightFile(removeButton.closest('[data-blacklight-custom-upload]'));
      return;
    }
    var option = event.target.closest('.product-detail__options [role="option"]');
    if (!option) return;
    var root = option.closest('[data-section-type="product"]');
    window.setTimeout(function () { updateBlacklightUpload(root); }, 0);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initializeBlacklightUploads(event.target);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'product-recommendations'
  var productRecommendationsSection = document.querySelector(".product-recommendations");
  if (productRecommendationsSection === null) { return; }
  // Build request URL
  var requestUrl = productRecommendationsSection.dataset.url;
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", requestUrl);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".product-recommendations").innerHTML;

      theme.peekCarousel.init(
        productRecommendationsSection,
        $('.js-related-product-carousel', productRecommendationsSection),
        '.productRecommendations',
        function() {
          return $(window).width() < 768
        },
        false
      );
    }
  };
  request.send();
};
// Reload the section in the editor when a setting changes
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].product-recommendations')) {
    loadProductRecommendationsIntoSection();
  }
});
document.addEventListener("shopify:section:unload", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].product-recommendations')) {
    theme.peekCarousel.destroy(
      $('.product-recommendations', event.target),
      $('.js-related-product-carousel', event.target),
      '.productRecommendations'
    );
  }
});
// Fetching the recommendations on page load
document.addEventListener("DOMContentLoaded", function(event) {
  loadProductRecommendationsIntoSection();
});

  } catch(e) { console.error(e); }
})();
})();
